import { WorkspaceNavImage } from '~/components/MainNavigation/WorkspacesNav/WorkspacesNavImage';
import { type DragWorkspaceItem } from '~/components/Shared/Drag/dragTypes';

type WorkspaceDragPreviewProps = {
  item: DragWorkspaceItem;
};

export const WorkspaceDragPreview = ({ item: { image } }: WorkspaceDragPreviewProps) => {
  return <WorkspaceNavImage className="size-8 border-2 border-white shadow-popover" image={image} />;
};
